import React from 'react';
import { Templates } from '../Templates';

export const CreateTemplateHandbook = (props) => {
  return <Templates forSelectTemplates />;
};
